export default "/images/vendor/flag-icons/flags/4x3/cefta.svg?159b824020be52ab9a1db4df65acf301";